import { useDraggable } from "@dnd-kit/core";
import { C_fondoGrisSuperClaro } from "../constantes/generales";

const Draggable = ({children, id, fondo=C_fondoGrisSuperClaro}) => {
  const {attributes, listeners, setNodeRef, transform} = useDraggable({id: id});
  
      const style = transform ? {
          transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
          touchAction: 'none',
          background: fondo,
          borderRadius: "4px",
      } :  { touchAction: 'none' };
  
      return(
          <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
              {children}
          </div>
      );
};

export default Draggable;